function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, props), React.createElement("path", {
    style: {
      "textIndent": 0,
      "textAlign": "start",
      "lineHeight": "normal",
      "textTransform": "none",
      "blockProgression": "tb",
      "InkscapeFontSpecification": "Sans"
    },
    d: "M 5 3 L 5 4 L 5 28 L 5 29 L 6 29 L 22 29 L 23 29 L 23 28 L 23 25 L 23 24.03125 L 23 23.1875 L 21.90625 22.125 L 21.0625 21.25 L 21 21.25 L 21 24.03125 L 21 25 L 21 27 L 7 27 L 7 5 L 21 5 L 21 8.03125 L 21 10.8125 L 21.90625 9.875 L 23 8.8125 L 23 6.875 L 23 4 L 23 3 L 22 3 L 6 3 L 5 3 z M 23.34375 11.28125 L 21.90625 12.71875 L 24.1875 15 L 12 15 L 12 17 L 24.1875 17 L 21.90625 19.28125 L 23.34375 20.71875 L 27.34375 16.71875 L 28.03125 16 L 27.34375 15.28125 L 23.34375 11.28125 z",
    color: "#000",
    overflow: "visible",
    fontFamily: "Sans"
  }));
};

export default __webpack_public_path__ + "static/media/exit.2b9e1cb9.svg";
export { SvgComponent as ReactComponent };